export const currencies = [
	{ name: 'US Dollar', value: 'USD' },
	{ name: 'Euro', value: 'EUR' },
	{ name: 'UAE Dirham', value: 'AED' },
	{ name: 'Afghani', value: 'AFN' },
	{ name: 'Lek', value: 'ALL' },
	{ name: 'Argentine Peso', value: 'ARS' },
	{ name: 'Australian Dollar', value: 'AUD' },
	{ name: 'Azerbaijan Manat', value: 'AZN' },
	{ name: 'Barbados Dollar', value: 'BBD' },
	{ name: 'Taka', value: 'BDT' },
	{ name: 'Bulgarian Lev', value: 'BGN' },
	{ name: 'Bermudian Dollar', value: 'BMD' },
	{ name: 'Brunei Dollar', value: 'BND' },
	{ name: 'Boliviano', value: 'BOB' },
	{ name: 'Brazilian Real', value: 'BRL' },
	{ name: 'Bahamian Dollar', value: 'BSD' },
	{ name: 'Pula', value: 'BWP' },
	{ name: 'Belize Dollar', value: 'BZD' },
	{ name: 'Canadian Dollar', value: 'CAD' },
	{ name: 'Swiss Franc', value: 'CHF' },
	{ name: 'Chilean Peso', value: 'CLP' },
	{ name: 'Yuan Renminbi', value: 'CNY' },
	{ name: 'Colombian Peso', value: 'COP' },
	{ name: 'Costa Rican Colon', value: 'CRC' },
	{ name: 'Czech Koruna', value: 'CZK' },
	{ name: 'Danish Krone', value: 'DKK' },
	{ name: 'Dominican Peso', value: 'DOP' },
	{ name: 'Algerian Dinar', value: 'DZD' },
	{ name: 'Egyptian Pound', value: 'EGP' },
	{ name: 'Fiji Dollar', value: 'FJD' },
	{ name: 'Pound Sterling', value: 'GBP' },
	{ name: 'Quetzal', value: 'GTQ' },
	{ name: 'Hong Kong Dollar', value: 'HKD' },
	{ name: 'Lempira', value: 'HNL' },
	{ name: 'Kuna', value: 'HRK' },
	{ name: 'Forint', value: 'HUF' },
	{ name: 'Rupiah', value: 'IDR' },
	{ name: 'New Israeli Sheqel', value: 'ILS' },
	{ name: 'Indian Rupee', value: 'INR' },
	{ name: 'Jamaican Dollar', value: 'JMD' },
	{ name: 'Yen', value: 'JPY' },
	{ name: 'Kenyan Shilling', value: 'KES' },
	{ name: 'Won', value: 'KRW' },
	{ name: 'Tenge', value: 'KZT' },
	{ name: 'Lao Kip', value: 'LAK' },
	{ name: 'Lebanese Pound', value: 'LBP' },
	{ name: 'Sri Lanka Rupee', value: 'LKR' },
	{ name: 'Liberian Dollar', value: 'LRD' },
	{ name: 'Moroccan Dirham', value: 'MAD' },
	{ name: 'Kyat', value: 'MMK' },
	{ name: 'Pataca', value: 'MOP' },
	{ name: 'Ouguiya', value: 'MRO' },
	{ name: 'Mauritius Rupee', value: 'MUR' },
	{ name: 'Rufiyaa', value: 'MVR' },
	{ name: 'Mexican Peso', value: 'MXN' },
	{ name: 'Malaysian Ringgit', value: 'MYR' },
	{ name: 'Cordoba Oro', value: 'NIO' },
	{ name: 'Norwegian Krone', value: 'NOK' },
	{ name: 'Nepalese Rupee', value: 'NPR' },
	{ name: 'New Zealand Dollar', value: 'NZD' },
	{ name: 'Sol', value: 'PEN' },
	{ name: 'Kina', value: 'PGK' },
	{ name: 'Philippine Peso', value: 'PHP' },
	{ name: 'Pakistan Rupee', value: 'PKR' },
	{ name: 'Zloty', value: 'PLN' },
	{ name: 'Qatari Rial', value: 'QAR' },
	{ name: 'Romanian Leu', value: 'RON' },
	{ name: 'Russian Ruble', value: 'RUB' },
	{ name: 'Saudi Riyal', value: 'SAR' },
	{ name: 'Solomon Islands Dollar', value: 'SBD' },
	{ name: 'Seychelles Rupee', value: 'SCR' },
	{ name: 'Swedish Krona', value: 'SEK' },
	{ name: 'Singapore Dollar', value: 'SGD' },
	{ name: 'Syrian Pound', value: 'SYP' },
	{ name: 'Baht', value: 'THB' },
	{ name: 'Pa’anga', value: 'TOP' },
	{ name: 'Turkish Lira', value: 'TRY' },
	{ name: 'Trinidad and Tobago Dollar', value: 'TTD' },
	{ name: 'New Taiwan Dollar', value: 'TWD' },
	{ name: 'Hryvnia', value: 'UAH' },
	{ name: 'Dong', value: 'VND' },
	{ name: 'Vatu', value: 'VUV' },
	{ name: 'Tala', value: 'WST' },
	{ name: 'East Caribbean Dollar', value: 'XCD' },
	{ name: 'West African CFA Franc', value: 'XOF' },
	{ name: 'Yemeni Rial', value: 'YER' },
	{ name: 'Rand', value: 'ZAR' },
];
